<section class="tray" role="dialog" [attr.aria-label]="heading" tabindex="-1">
  <header class="tray__header">
    <span class="tray__title">{{ heading }}</span>
    <span class="tray__count" *ngIf="hasCount">{{ count }}</span>
    <span class="tray__spacer"></span>
    <button type="button" class="tray__close" [attr.aria-label]="'Close ' + heading" (click)="close()">
      <svg-icon src="assets/icons/close-icon.svg" class="tray__close-icon" aria-hidden="true"></svg-icon>
    </button>
  </header>

  <div class="tray__body app-scrollbar">
    <div class="tray__empty" *ngIf="isEmpty">
      <svg-icon src="assets/icons/circle-check.svg" class="tray__empty-icon" aria-hidden="true"></svg-icon>
      <span class="tray__empty-message">{{ emptyMessage }}</span>
    </div>

    <div class="tray__items" *ngIf="!isEmpty">
      <ng-content></ng-content>
    </div>
  </div>

  <footer class="tray__footer" *ngIf="hasFooterNote">{{ footerNote }}</footer>
</section>
